import { DisplayWindow, DisplayHeader, Display } from '../display'
import WindowMenu from './WindowMenu'
import { IconMinimize, IconClose } from './icons'

// Per-window chrome: a header with the title, an ellipsis "more" menu (feature
// actions like edit/delete), and the two primary controls on the right
// (minimize, close). The body is whatever the feature renders. Clicking anywhere
// focuses the window.
function GridWindow({
  title,
  active,
  canMinimize,
  canClose = true,
  menuItems,
  onFocus,
  onMinimize,
  onClose,
  children,
}) {
  return (
    <div
      className={'grid-window' + (active ? ' is-active' : '')}
      onMouseDownCapture={onFocus}
    >
      <DisplayWindow
        header={
          <DisplayHeader
            actions={
              <>
                <button
                  type="button"
                  title={canMinimize ? 'Minimize' : 'At least one window must stay visible'}
                  aria-label="Minimize"
                  disabled={!canMinimize}
                  onClick={onMinimize}
                >
                  <IconMinimize />
                </button>
                <button
                  type="button"
                  title={canClose ? 'Close' : 'At least one window must stay open'}
                  aria-label="Close"
                  disabled={!canClose}
                  onClick={onClose}
                >
                  <IconClose />
                </button>
              </>
            }
          >
            <div className="grid-window-head">
              <span className="display-header-title">{title}</span>
              <WindowMenu extraItems={menuItems} />
            </div>
          </DisplayHeader>
        }
      >
        <Display fill>{children}</Display>
      </DisplayWindow>
    </div>
  )
}

export default GridWindow
